import './style.scss';

function Account(props) {
  return (
    <div className="Account">
      {props.children}
    </div>
  );
}

export default Account;